"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Set difference */
function diff(setA, setB) {
    var difference = new Set(setA);
    for (const elem of setB) {
        difference.delete(elem);
    }
    return difference;
}
exports.diff = diff;
function union(setA, setB) {
    let union = new Set(setA);
    for (const elem of setB) {
        union.add(elem);
    }
    return union;
}
exports.union = union;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0RXh0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vdHMvc2V0RXh0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEscUJBQXFCO0FBQ3JCLFNBQWdCLElBQUksQ0FBSSxJQUFZLEVBQUUsSUFBWTtJQUNoRCxJQUFJLFVBQVUsR0FBRyxJQUFJLEdBQUcsQ0FBSSxJQUFJLENBQUMsQ0FBQztJQUNsQyxLQUFLLE1BQU0sSUFBSSxJQUFJLElBQUksRUFBRTtRQUN2QixVQUFVLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO0tBQ3pCO0lBQ0QsT0FBTyxVQUFVLENBQUM7QUFDcEIsQ0FBQztBQU5ELG9CQU1DO0FBRUQsU0FBZ0IsS0FBSyxDQUFJLElBQVksRUFBRSxJQUFZO0lBQ2pELElBQUksS0FBSyxHQUFHLElBQUksR0FBRyxDQUFJLElBQUksQ0FBQyxDQUFDO0lBQzdCLEtBQUssTUFBTSxJQUFJLElBQUksSUFBSSxFQUFFO1FBQ3ZCLEtBQUssQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDakI7SUFDRCxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUM7QUFORCxzQkFNQyJ9


//////////////////
// WEBPACK FOOTER
// ../normalize-js/dist/ts/setExt.js
// module id = 797
// module chunks = 0